import { VStack } from "@chakra-ui/react";
import { Field, FormInput, FormSelect, FormTextarea } from "@/components/jobOffer/ui/inputs";
import { SectionCard, SectionHeader, Grid2 } from "@/components/jobOffer/ui/layout";
import { CAMPAIGN_LANGUAGE_OPTIONS, CAMPAIGN_LANGUAGE_AUTO_VALUE } from "@/components/campaign/campaignLanguageOptions";

const CAMPAIGN_LANGUAGE_VALUES = new Set(CAMPAIGN_LANGUAGE_OPTIONS.map((o) => o.value));

const StepBasics = ({ values, onChange }) => {
    const set = (key, val) => onChange({ ...values, [key]: val });

    // Old campaigns may have arbitrary free-text values from before this became a fixed dropdown --
    // filter those out here rather than passing them into FormSelect, so an unrecognized value just
    // shows up as "not selected" instead of risking the Select choking on an item outside its collection.
    // Left untouched in `values.languages` unless the user actually changes the selection.
    const selectedLanguages = (values.languages ?? []).filter((v) => CAMPAIGN_LANGUAGE_VALUES.has(v));

    // "Wykrywaj automatycznie" doesn't make sense combined with specific languages (mirrors the
    // mutually-exclusive option pattern used elsewhere, e.g. StepLeadSource.jsx SYSTEM_FIELD_OPTIONS):
    // picking "auto" clears everything else, picking anything else drops "auto".
    const setLanguages = (next) => {
        const hadAuto = selectedLanguages.includes(CAMPAIGN_LANGUAGE_AUTO_VALUE);
        const hasAuto = next.includes(CAMPAIGN_LANGUAGE_AUTO_VALUE);
        if (hasAuto && !hadAuto) {
            set("languages", [CAMPAIGN_LANGUAGE_AUTO_VALUE]);
        } else if (hasAuto && next.length > 1) {
            set("languages", next.filter((v) => v !== CAMPAIGN_LANGUAGE_AUTO_VALUE));
        } else {
            set("languages", next);
        }
    };

    return (
        <VStack w="full" align="stretch" gap={4}>
            <SectionCard>
                <SectionHeader number={1} title="Podstawowe informacje" subtitle="Nazwa kampanii i jej wirtualnego handlowca" />
                <VStack align="stretch" gap={4}>
                    <Field label="Nazwa kampanii" required>
                        <FormInput value={values.name} onChange={(e) => set("name", e.target.value)} placeholder="np. MetaAds - Agenci AI - sierpień 2026" />
                    </Field>
                    <Grid2>
                        <Field label="Nazwa Handlowca AI" hint='np. "Marek - Doradca AI"'>
                            <FormInput value={values.agentDisplayName ?? ""} onChange={(e) => set("agentDisplayName", e.target.value)} />
                        </Field>
                    </Grid2>
                    <Field label="Opis kampanii" hint="Krótki opis wewnętrzny">
                        <FormTextarea value={values.description ?? ""} onChange={(e) => set("description", e.target.value)} rows={2} />
                    </Field>
                    <Field label="Języki komunikacji">
                        <FormSelect
                            value={selectedLanguages}
                            onChange={setLanguages}
                            options={CAMPAIGN_LANGUAGE_OPTIONS}
                            placeholder="Wybierz języki"
                            multiple
                        />
                    </Field>
                </VStack>
            </SectionCard>
        </VStack>
    );
};

export default StepBasics;
